import React, {useEffect, useState, useMemo } from "react";
import { useEffectOnceWhen } from "rooks";

import { setHome, setLoading, setReading } from "./store/stageSlice";

import "./Excelsior.css";

import { useSelector, useDispatch } from "react-redux";
import {
  setCurrentIssueID,
  setCurrentIssueName,
  setAdmin,
  setLockMode,
  setLoadObject,
} from "./store/readerSlice";
import { GetBookData, SetBookData, SetIssuePDFRef } from "./store/ExcelsiorDataContext";
import BraveNotification from "./utils/BraveNotification"
import { ExcelsiorChrome } from "./ExcelsiorChrome";

import { ExcelsiorPageViewer } from "./ExcelsiorPageViewer";

//REMOVE EVERYTHING BELOW THIS FOR PRODUCTION BUILD
import localPDF from "../comic/NightJackal_1_2_3_RS_E.pdf";


import localJWK from "../comic/NightJackal_1_2_3_RS_key.json";
import localIssueObj from "../comic/NJ.json";  


//import localPDF from "../temp/Plush 005 (2023). (Digital) .(Zone-Empire).cbr";

//Plush 005 (2023) (Digital) (Zone-Empire).cbr


// import { decryptFile } from "./security/index.js";

const ExcelsiorReaderFunc = () => {
  //FOR TESTING ONLY
 //const localized = false;

  //CONTEXTUAL PROPERTIES
  const bookData = GetBookData();
  const setBookData = SetBookData();
  const setIssuePDFRef = SetIssuePDFRef();

  //let localJWK = "Unencrypted";
  //let localPDF;

  //REDUX
  const dispatch = useDispatch();
  // const getIssueURI = useSelector(state => state.reader.currentIssueURI);
  // const getIssueID = useSelector(state => state.reader.currentIssueID);
  const getLoadObject = useSelector(state => state.reader.loadObject);

  const setIssueIDStore = (v) => dispatch(setCurrentIssueID(v));
  const setIssueNameStore = (v) => dispatch(setCurrentIssueName(v));
  // const setIssueURIStore = (v) => dispatch(setCurrentIssueURI(v));
  const setAdminStore = (v) => dispatch(setAdmin(v));
  const setLockModeStore = (v) => dispatch(setLockMode(v))

  const setLoadObjectStore = (v) => dispatch(setLoadObject(v))

  const [book, setBook] = useState(false);

  
// dispatch(setHome(true))
  useEffectOnceWhen(() => {

    dispatch(setLoading());

    setLoadObjectStore(({
      cinemaFile: localIssueObj,  // Store the issue's metadata (JSON)
      totalPages: localIssueObj.layout.pages.length,  // Store the number of pages from the JSON
      edition: "local"  // This could be useful to distinguish between local and remote issues
  }));


    if (bookData.length > 0) {
      setBook(true);
    }

    setAdminStore(false);

  }, [bookData, localIssueObj, setLoadObjectStore]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    //dispatch(setHome())


      const timer = setTimeout(() => {
        async function loadBook() {
          dispatch(setLoading());


            if (bookData[5] === "upload") {
              await uploadedBook()
            } else {
              
              //Perma time!

              getPermaBook()
          
            }

        }
        loadBook();
        clearTimeout(timer);
      }, 100);
      return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [book]);



const uploadedBook = async() => {
  setLoadObjectStore(null)
  setLockModeStore(true)
    console.log("upload")
    if(!bookData[0]){
      dispatch(setHome())
    }else{
      setCurrentIssueID(new Date())
      dispatch(setReading());
  }
}

const getPermaBook = async () =>{
  console.log("Perma")

  if(!getLoadObject){
    dispatch(setHome())
    console.log("No get load object")
    return
  }


  // Check if localPDF is a URL (string) or already a Blob
  let pdfData;
  if (typeof localPDF === 'string') {
      // Fetch the PDF if it's a URL
      try {
          const response = await fetch(localPDF);  // Fetch the PDF data
          if (!response.ok) {
              throw new Error(`Failed to fetch PDF: ${response.statusText}`);
          }
          pdfData = await response.blob();  // Convert to Blob
      } catch (error) {
          console.error('Error fetching PDF:', error);
          return;
      }
  } else {
      // If it's already a Blob, just use it directly
      pdfData = localPDF;
  }


  setIssuePDFRef(localPDF);  // Set the local PDF into context
  setBookData([pdfData, localIssueObj, localJWK, "pdf", true, null]);  // Set book data


  let issueObject = deepCopy(getLoadObject.cinemaFile);
  console.log(issueObject)
  if(getLoadObject.cinemaFile?.layout?.pages?.length){
    issueObject.layout.pages.length = getLoadObject.totalPages;
  }
  

  //setBookData([new Blob(), issueObject, "Unencrypted", "perma", true, getLoadObject.edition])
  //setBookData([new Blob(), issueObject, "Unencrypted", "pdf", true, getLoadObject.edition])

  setLockModeStore(false)
  parseIssueObjectHeader(getLoadObject.cinemaFile)
  dispatch(setReading());
 
}

function deepCopy(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(deepCopy);
  }

  const newObj = {};

  for (const key in obj) {
    newObj[key] = deepCopy(obj[key]);
  }

  return newObj;
}


  const parseIssueObjectHeader = (issO) => {
    if (!issO) {
      return;
    }
    var str = issO.head.series.concat(
      " #",
      issO.head.num,
      ": ",
      issO.head.title
    );
    setIssueNameStore(str);

    setIssueIDStore(issO.head.uid);
  };

  return useMemo(() => {
    return (
      <>
        {(bookData[0] !== null) & (bookData[1] !== null) ? (
          <>
         
          <div onContextMenu={(e) => e.preventDefault()}>
          
            <ExcelsiorChrome />
            <ExcelsiorPageViewer />
            <BraveNotification />
          </div>
          </>
        ) : null}
      </>
    );
  }, [bookData]);
};

export const ExcelsiorReader = React.memo(ExcelsiorReaderFunc);
